import { Component, input } from '@angular/core';
import { AppMenu } from './app.menu';
import { DividerModule } from 'primeng/divider';
import { ImageModule } from 'primeng/image';
import { SkeletonModule } from 'primeng/skeleton';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-sidebar',
	standalone: true,
	imports: [AppMenu, DividerModule, ImageModule, SkeletonModule],
	template: ` <div class="layout-sidebar bg-navy-gradient !rounded-none">
		<div class="!mt-5 !mb-10">
			<a class="layout-sidebar-logo !flex !justify-center" routerLink="/dashboard">
				@if (sub$() && !sub$().closed) {
					<div class="flex flex-col justify-center gap-2">
						<p-skeleton width="8rem" borderRadius="16px" />
						<p-skeleton width="5rem" borderRadius="16px" />
						<p-skeleton width="10rem" borderRadius="16px" />
					</div>
				} @else {
					<div class="flex items-center gap-3 w-full">
						<img [src]="logo() || 'assets/images/business.svg'" alt="Logo" class="h-12" />
						<div class="flex flex-col">
							<span class="text-white/80 font-bold"> Human Resource </span>
							<span class="text-white/80 font-bold"> Information System </span>
						</div>
					</div>
				}
			</a>
		</div>
		<app-menu></app-menu>
	</div>`
})
export class AppSidebar {
	logo = input<string | null>(null);
	sub$ = input.required<Subscription>();
}
